import module from "../module";

module.directive('money', ['$locale', '$filter', function($locale, $filter) {

    // For input validation
    var isValid = function(val) {
        return angular.isNumber(val) && !isNaN(val);
    };

    // Saved to your $scope/model
    var toModel = function(val) {
        return parseInt(val.replace(/[^0-9]+/g, "")) || 0;
    };

    // Link to DOM
    var link = function($scope, $element, $attrs, $ngModel) {
        function toView(val) {
            var converted =  val ? $filter('currency')(val, '', 0) : "";
            if (converted !== val) {
                var caretPosition = $element[0].selectionStart;
                $ngModel.$setViewValue(converted);
                $ngModel.$render();
                //$element[0].selectionStart = $element[0].selectionEnd = caretPosition + caretPosition / 4;
            }
            return converted;
        }
        $ngModel.$formatters.push(toView);
        $ngModel.$parsers.push(toModel);
        $ngModel.$validators.currency = isValid;

        $element.on('keyup', function($event) {
            $ngModel.$viewValue = toView($ngModel.$modelValue);
        });
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: link
    };
}]);



// WEBPACK FOOTER //
// ./src/modules/shared/directives/MoneyDirective.js